import { Navigate } from 'react-router-dom';
import { useCustomerAuth } from '../../contexts/CustomerAuthContext';

const CustomerProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useCustomerAuth();
  
  // Loading durumunda bekle
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600 dark:text-gray-400">Yükleniyor...</p>
        </div>
      </div>
    );
  }
  
  // Authenticated değilse login'e yönlendir
  if (!isAuthenticated) {
    const isSubdomain = window.location.hostname === 'musteri.jansoft.online';
    return <Navigate to={isSubdomain ? "/login" : "/musteri-portal/login"} replace />;
  }

  return children;
};

export default CustomerProtectedRoute;
